// extracted by mini-css-extract-plugin
export default {"itemList":"itemList_itemList__wnR0m"};